import React from 'react'
import { LOCALE } from '../../../constants/activity-constants'
import images from '../../../assets/images/awards/images'

const ec = LOCALE === 'es-EC'
const arg = LOCALE === 'es-AR'
const cl = LOCALE === 'es-CL'

const default_sources = {
  mobile: images.awardsMbCo,
  desktop: images.awardsPcCo,
}
const sources =
  {
    'es-CO': default_sources,
    'es-EC': {
      mobile: images.awardsMbEc,
      desktop: images.awardsPcEc,
    },
    'es-AR': {
      mobile: images.awardsMbArg,
      desktop: images.awardsPcArg,
    },
    'es-CL': {
      mobile: images.awardsMbCl,
      desktop: images.awardsPcCl,
    },
  }[LOCALE] || default_sources

const TextByCountry1 = () => {
  if (LOCALE === 'es-EC') {
    return (
      <>
        <strong>
          ¡Quedan pocos días para que puedas ganarte <span className='--pink'>1 iPhone 13</span> y muchos más
          premios jugando!
        </strong>
      </>
    )
  }
  if (arg) {
    return (
      <>
        <strong>Donde podrás ganar desde</strong> un espectacular Kit Nosotras,
        hasta 1 Tablet.
      </>
    )
  } else if (cl) {
    return (
      <>
        <strong>Donde podrás ganar desde</strong> un espectacular Kit Nosotras,
        hasta 1 Laptop.
      </>
    )
  } else {
    return (
      <>
        Donde podrás <strong>ganar</strong> desde un espectacular Kit Nosotras,
        hasta 1 Iphone {ec ? 13 : 14}.
      </>
    )
  }
}
const TextByCountryMobile1 = () => {
  if (arg) {
    return (
      <>
        Desbloqueá los planetas <br />
        ingresando las claves personales que encontrás <br /> en los empaques
        Nosotras. <br />
        <strong className="f-contentHomeUniverse__left__text__strongText">
          ¡Canjeá, jugá y ganá 1 Tablet, entre <br /> muchos premios más!
        </strong>
      </>
    )
  } else if (cl) {
    return (
      <>
        Desbloquea los planetas ingresando <br />
        las claves personales que encuentras <br />
        en tus empaques Nosotras.
        <strong className="f-contentHomeUniverse__left__text__strongText">
          ¡Canjea, <br />
          juega y gana 1 Laptop, entre <br /> muchos premios más!
        </strong>
      </>
    )
  } else {
    return (
      <>
        Desbloquea los planetas, ingresando <br /> las claves personales que
        encuentras <br /> en tus empaques Nosotras.
        <strong className="f-contentHomeUniverse__left__text__strongText">
          ¡Redime, <br /> juega y gana un Iphone {ec ? 13 : 14}, entre <br />{' '}
          muchos premios más!
        </strong>
      </>
    )
  }
}
const TextByCountry2 = () => {
  let text
  if (arg) {
    text = `¡vos volves a ser${' '}`
  } else {
    text = `¡tú vuelves a ser${' '}`
  }
  return (
    <p className="f-contentHomeUniverse__left__title__spanTitle__textBlue">
      {text}
      <strong className="f-contentHomeUniverse__left__title__spanTitle__textPink">
        la protagonista{arg ? '!' : ''}
      </strong>
      {arg ? '' : '!'}
    </p>
  )
}
const TextByCountry3 = () => {
  let text, text2, text3
  if (arg) {
    text = 'Desbloqueá los planetas ingresando las claves'
    text2 = 'personales que encontrás en los empaques Nosotras.'
    text3 = '¡Jugá las veces que querás y ganá muchos premios!'
  } else {
    text = 'Desbloquea los planetas, ingresando las claves'
    text2 = 'personales que encuentras en tus empaques Nosotras.'
    text3 = '¡Juega las veces que quieras y gana muchos premios!'
  }
  return (
    <p>
      <strong className="f-contentHomeUniverse__left__text__strongText">
        Aquí no hay límites, porque siempre {arg ? 'ganás' : 'ganas'}.
      </strong>{' '}
      <br />
      {text}
      <br />
      {text2} <br />
      <strong className="f-contentHomeUniverse__left__text__strongText">
        {' '}
        {text3}
      </strong>
    </p>
  )
}
export const ImageByRegion1 = ({ isMobile, classname }) => {
  return (
    <img
      src={isMobile ? sources.mobile : sources.desktop}
      alt="premios para las ganadoras"
      className={`f-contentHomeUniverse__center__imgPremios`}
    />
  )
}

export const text1 = TextByCountry1()
export const text2 = TextByCountry2()
export const text3 = TextByCountry3()
export const textMobile1 = TextByCountryMobile1()
